import { Icons, DeprecatedIcons } from "../../../tokens/ts/_icons";
import { kebabToJS } from "../../../_utilities";

const convertIcon = (icon: HTMLElement) => {
  if (typeof window !== "undefined") {
    const iconClassname = icon.classList[1];
    const name = kebabToJS(iconClassname.replace("ico-", ""));
    let isDeprecated = false;
    let svg = (<any>Icons)?.[name];
    if (!svg) {
      isDeprecated = true;
      svg = (<any>DeprecatedIcons)?.[name];
      if (svg) {
        console.warn(
          `[GBG] Icon '${iconClassname}' is deprecated and will soon be removed. Use an icon from the current set instead.`
        );
        //get size
        const parts = iconClassname.split("-");
        let size = parts?.[parts.length - 1] ?? "24";
        icon.style.width = size + "px";
        icon.style.height = size + "px";
      } else {
        svg = Icons.helpCircle;
        console.warn(
          `[GBG] Icon '${iconClassname}' is not available. Use an icon from the current set instead.`
        );
      }
    }
    const svgElementContainer = document.createElement("div");
    svgElementContainer.innerHTML = svg;
    const svgElement = svgElementContainer.childNodes[0] as any;
    if (icon.id) {
      svgElement.id = icon.id;
    }
    svgElement.classList = icon.classList;
    svgElement.setAttribute("style", icon.getAttribute("style"));
    const strokeWidth = window
      .getComputedStyle(icon)
      .getPropertyValue("stroke-width");
    const height = window.getComputedStyle(icon).getPropertyValue("height");
    const width = window.getComputedStyle(icon).getPropertyValue("width");

    if (isDeprecated) {
      const color = window.getComputedStyle(icon).getPropertyValue("color");
      svgElement.querySelectorAll("[stroke]").forEach((node: any) => {
        node.setAttribute("stroke", color);
      });
      svgElement.querySelectorAll("[fill]").forEach((node: any) => {
        node.setAttribute("fill", color);
      });
    }

    svgElementContainer
      .querySelectorAll("[stroke-width]")
      .forEach((node: any) => {
        node.setAttribute("stroke-width", strokeWidth);
      });

    svgElementContainer.querySelectorAll("[height]").forEach((node: any) => {
      node.setAttribute("height", height);
    });

    svgElementContainer.querySelectorAll("[width]").forEach((node: any) => {
      node.setAttribute("width", width);
    });

    if (icon.classList.contains("icon--unwrapped")) {
      icon?.parentNode?.replaceChild(svgElement, icon);
    } else {
      icon.appendChild(svgElement);
    }
  }
};

export const init = (iconElement?: HTMLElement): void => {
  if (typeof window !== "undefined") {
    if (iconElement) return convertIcon(iconElement);
    document
      .querySelectorAll<HTMLElement>("[class^='icon']")
      .forEach((icon) => {
        convertIcon(icon);
      });
  }
};

export const initChildren = (containerElement: HTMLElement | string) => {
  if (typeof window !== "undefined") {
    if (typeof containerElement == "string") {
      containerElement = document.querySelector<HTMLElement>(containerElement);
    }
    containerElement
      .querySelectorAll<HTMLElement>("[class^='icon']")
      .forEach((icon) => {
        convertIcon(icon);
      });
  }
};

export default {
  init,
};
